import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { explainWithAiWidgetIdSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetIdSelector";
import {
  setExplainWithAIBillingData,
  setExplainWithAiNewDataNeeded,
} from "@/store/explain-with-ai/explainWithAiSlice";
import { explainWithAiCurrentBillingDataSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiCurrentBillingDataSelector";
import { addBillingExplorerExplainWithAiDataThunk } from "@/store/explain-with-ai/thunks/billing-explorer/addBillingExplorerExplainWithAiDataThunk";

export const addExplainWitAiDataThunk = createAsyncThunk(
  "resourceExplorer/addExplainWitAiData",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const currentData = explainWithAiCurrentBillingDataSelector(state);
    if (!currentData) {
      return;
    }
    const widgetId = explainWithAiWidgetIdSelector(state);
    if (widgetId) {
      dispatch(setExplainWithAIBillingData([currentData]));
      dispatch(setExplainWithAiNewDataNeeded(false));
    } else {
      dispatch(addBillingExplorerExplainWithAiDataThunk());
      dispatch(setExplainWithAiNewDataNeeded(false));
    }
  },
);
